import { createFileRoute, linkOptions } from '@tanstack/react-router'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'

import NotFoundResource from '@/components/router/not-found-resource'
import RouteSheet from '@/components/sheets/route-sheet'
import { pageSearchAtom } from '@/stores/page-search.atom'

import { Route as InsistencesRoute } from '../route'

export const Route = createFileRoute('/app/data/insistences/$coverageUuid')({
  component: RouteComponent,
  errorComponent: (props) => {
    const { t } = useTranslation()

    return (
      <NotFoundResource
        {...props}
        resourceType={t(
          'resource-not-found.not-found.insistence.resource-type',
        )}
        backTo={t(
          'resource-not-found.not-found.insistence.back-to-insistences-list',
        )}
        backToLink={backToLink}
      />
    )
  },
})

const backToLink = linkOptions({
  from: Route.fullPath,
  to: '..',
})

function RouteComponent() {
  const pageSearch = useAtomValue(pageSearchAtom)
  const closeLink =
    pageSearch[InsistencesRoute.fullPath] ??
    linkOptions({ from: InsistencesRoute.fullPath, to: '..' })

  return <RouteSheet closeLink={closeLink} />
}
